import { render } from "./SkillsPage.vue?vue&type=template&id=0ccb8ada&scoped=true"
import script from "./SkillsPage.vue?vue&type=script&lang=js"
export * from "./SkillsPage.vue?vue&type=script&lang=js"

import "./SkillsPage.vue?vue&type=style&index=0&id=0ccb8ada&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ccb8ada"

export default script